<template>
  <BModal
    v-model="modal"
    title="Edit Pending Action"
    ref="modalRef"
    ok-title="Save"
    ok-variant="success"
    @show="initializePendingAction"
    @ok="handlePendingActionSubmission"
  >
    <div class="text-center">
      <BFormRadioGroup
        v-model="fulfilled"
        :options="fulfilledOpts"
        :state="fullfilledError !== null ? false : null"
        class="mb-3"
        value-field="item"
        text-field="name"
      />
      <BFormGroup
        id="input-group-date"
        label="Date:"
        label-for="date"
        class="floating-group"
      >
        <BFormInput
          id="date"
          v-model="date"
          type="date"
          size="sm"
          style="font-size: 0.85rem"
          :class="{ 'is-invalid': dateError !== null }"
        />
      </BFormGroup>
      <BFormGroup
        id="input-group-description"
        label="Description:"
        label-for="description-input"
        class="floating-group"
      >
        <BFormTextarea
          id="description-input"
          v-model="description"
          :class="{ 'is-invalid': descriptionError !== null }"
          placeholder="Enter something..."
          rows="3"
          style="font-size: 0.85rem"
        />
      </BFormGroup>
    </div>
  </BModal>
</template>
<script>
import {
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BFormRadioGroup,
} from "bootstrap-vue-next";

export default {
  name: "EditPendingActionModal",
  props: {
    acctUid: {
      type: String,
      required: true,
    },
    pendingAction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      date: null,
      dateError: null,
      description: null,
      descriptionError: null,
      fulfilled: null,
      fullfilledError: null,
      fulfilledOpts: [
        { name: "Fulfilled", item: "true" },
        { name: "Unfulfilled", item: "false" },
      ],
    };
  },
  components: {
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormRadioGroup,
  },
  emits: ["pendingActionEdited"],
  methods: {
    initializePendingAction() {
      console.log("Received pendingAction prop:", this.pendingAction);
      if (this.pendingAction) {
        this.fulfilled = this.pendingAction.fulfilled;
        this.date = this.pendingAction.created_date;
        this.description = this.pendingAction.content;
      }
    },
    validateForm() {
      let isValid = true;

      if (this.fulfilled === null) {
        this.fullfilledError = "Fulfillment status is required.";
        isValid = false;
      } else {
        this.fullfilledError = null;
      }

      if (!this.date) {
        this.dateError = "Date is required.";
        isValid = false;
      } else {
        this.dateError = null;
      }

      if (!this.description) {
        this.descriptionError = "Description is required.";
        isValid = false;
      } else {
        this.descriptionError = null;
      }

      return isValid;
    },
    async handlePendingActionSubmission(bvEvt) {
      try {
        bvEvt.preventDefault(); // Prevent the modal from closing immediately
        const formIsValid = this.validateForm();
        if (!formIsValid) return;

        if (!this.acctUid) {
          this.$notify.notifyError(
            "Account context is missing. Please select an account and try again."
          );
          return;
        }

        await this.$api.put(`/pending-actions/${this.pendingAction.uid}`, {
          acct_uid: this.acctUid,
          created_date: this.date,
          content: this.description,
          fulfilled: this.fulfilled,
        });

        this.$refs.modalRef.hide();
        this.$notify.notifySuccess("Pending action saved successfully.");
        this.$emit("pendingActionEdited");
        this.resetModalState();
      } catch (error) {
        console.error("Error submitting pending action:", error);
        this.$notify.notifyError(
          "An error occurred while saving the pending action. Please try again."
        );
      }
    },
    resetModalState() {
      this.fulfilled = null;
      this.fullfilledError = null;
      this.date = null;
      this.description = null;
      this.dateError = null;
      this.descriptionError = null;
    },
  },
};
</script>
